import React from 'react';
import { useAddTranslationComponent } from './useAddTranslationComponent';
import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppButton from '../../../../components/designe/app-button/AppButton';
import { useStyles } from './AddTranslation.styles';
import theme from '../../../../styles/theme';
import { ITranslation } from '../../../../types/interfaces/translation';
import AppFormTextField from '../../../../components/designe/app-form-text-field';
import AppFormSelectWrapper from '../../../../components/designe/app-form-select-wrapper';

interface IAddTranslationProps {
  translation: ITranslation;
  onClose: () => void;
}

export default function AddTranslation(props: IAddTranslationProps) {
  const { translation, onClose } = props;
  const { t } = useTranslation();
  const { formik, isLoading, languages } = useAddTranslationComponent(
    onClose,
    translation,
  );
  const { classes } = useStyles(theme);

  const languageOptions = languages?.map((l) => ({
    id: l.id,
    name: l.name || l.key,
  }));

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.key')}
              fullWidth
              name="key"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <AppFormSelectWrapper
              label={t('common.language')}
              name="language"
              options={languageOptions}
              defaultValue={languageOptions?.find(
                (l) => l.id === formik.values.language?.id,
              )}
              formik={formik}></AppFormSelectWrapper>
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.value')}
              fullWidth
              name="value"
              formik={formik}
            />
          </Grid>
        </Grid>
        <Box className={classes.addTranslationButtonWrapper}>
          <AppButton variant="outlined" onClick={() => onClose()}>
            {t('common.cancel')}
          </AppButton>
          <AppButton type="submit" loader={isLoading}>
            {translation ? t('common.update') : t('common.create')}
          </AppButton>
        </Box>
      </form>
    </Box>
  );
}
